module.exports = __webpack_public_path__ + "static/Al-Marshall-777960ed169cb7f3ab02287f2b20e921.jpg";